module.exports = __webpack_public_path__ + "static/img/logo5.85d4256d.png";